import { render, staticRenderFns } from "./m-deep-badge-aurora.vue?vue&type=template&id=52c08eb9&scoped=true&"
import script from "./m-deep-badge-aurora.vue?vue&type=script&setup=true&lang=ts&"
export * from "./m-deep-badge-aurora.vue?vue&type=script&setup=true&lang=ts&"
import style0 from "./m-deep-badge-aurora.vue?vue&type=style&index=0&id=52c08eb9&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52c08eb9",
  null
  
)

export default component.exports